import { Box, Stack, Tooltip } from '@mui/material'
import { CardItem } from 'ComponentLibrary/src/atoms/CardItem/CardItem'
import { Headline } from 'ComponentLibrary/src/piazza/text/Headline/Headline'
import { DeviationAnalysisExportCopy, exportDeviationAnalysisToExcel } from './exportDeviationAnalysis'
import { DeviationAnalysisType, mapDeviationAnalysisSchemaToTable, TinyButton, tokens, ValuationDeviationOption } from 'ComponentLibrary'
import { DownloadSimpleIcon } from '@phosphor-icons/react'

export type DeviationAnalysisExportCardCopy = {
    sectionTitle: string
    downloadTooltip: string
    downloadButtonLabel: string
}

const DEFAULT_DEVIATION_ANALYSIS_EXPORT_CARD_COPY: DeviationAnalysisExportCardCopy = {
    sectionTitle: 'Export',
    downloadTooltip: 'Abweichungsanalyse herunterladen',
    downloadButtonLabel: 'Excel herunterladen',
}

type DeviationAnalysisSectionHeadProps = {
    assetTitle: string
    baseValuation?: ValuationDeviationOption
    comparisonValuation?: ValuationDeviationOption
    deviationAnalysis?: DeviationAnalysisType
    copy?: DeviationAnalysisExportCardCopy
    exportCopy?: DeviationAnalysisExportCopy
    locale?: string
}

export function DeviationAnalysisExportCard({
    assetTitle,
    baseValuation,
    comparisonValuation,
    deviationAnalysis,
    copy = DEFAULT_DEVIATION_ANALYSIS_EXPORT_CARD_COPY,
    exportCopy,
    locale,
}: DeviationAnalysisSectionHeadProps) {
    const transformedDeviationAnalysis = mapDeviationAnalysisSchemaToTable(deviationAnalysis)

    return (
        <CardItem>
            <Stack direction="column" gap={tokens.SizingSpacing150}>
                <Headline variant="headline3" title={copy.sectionTitle} />
                <Tooltip title={copy.downloadTooltip}>
                    <Box>
                        <TinyButton
                            leftIcon={<DownloadSimpleIcon />}
                            label={copy.downloadButtonLabel}
                            onClick={() =>
                                exportDeviationAnalysisToExcel({
                                    deviationAnalysis: transformedDeviationAnalysis,
                                    assetTitle,
                                    baseValuation,
                                    comparisonValuation,
                                    copy: exportCopy,
                                    locale,
                                })
                            }
                        />
                    </Box>
                </Tooltip>
            </Stack>
        </CardItem>
    )
}
